import { removeUserDevice } from "../crmServices/loginService";
import { isUserLoggedIn, getPatientAuthToken, getUserAuthToken } from "./util";
import axios from "axios";
import { serviceConstants } from "./constants";

export const handleError = (error, skipRedirect = false) => {
    if (error.status === 401) {
        // Don't redirect on public routes
        if (skipRedirect) {
            return;
        }
        if (isUserLoggedIn()) {
            if (error.message === "Token has wrong Device ID") {
                window.localStorage.clear();
                window.location.href = "/";
            } else {
                removeUserDevice();
                window.location.href = "/";
            }
        } else {
            // Only redirect if not on a public route
            const currentPath = window.location.pathname;
            const publicRoutes = ["/login", "/fast-login"];
            if (!publicRoutes.includes(currentPath)) {
                window.localStorage.clear();
                window.location.href = "/";
            }
        }
    }
};

export const apiInterfaceForJson = (url, method, data, signal, timeout) => {
    let token = getUserAuthToken();
    return axios
        .request({
            url: serviceConstants.API_HOST_NAME + url,
            method: method,
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            },
            data: data,
            signal: signal,
            // 60s default; long-running endpoints (AI generation) pass a higher value
            timeout: timeout || 60000
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            if (error.response) {
                // Check if we're on a public route - don't redirect for those
                const currentPath = window.location.pathname;
                const publicRoutes = ["/login", "/fast-login"];
                const skipRedirect = publicRoutes.includes(currentPath);
                handleError(error.response, skipRedirect);
                // Re-throw the error so calling code can handle it
                throw error;
            }
            throw error;
        });
};

export const apiInterfaceForFormData = (url, method, formData) => {
    let token = getUserAuthToken();
    if (!token) {
        token = getPatientAuthToken();
    }
    return axios
        .request({
            url: serviceConstants.API_HOST_NAME + url,
            method: method,
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + token
            },
            data: formData,
            timeout: 120000 // 120 seconds timeout for file uploads
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            if (error.response) {
                handleError(error.response);
                // Re-throw the error so calling code can handle it
                throw error;
            }
            throw error;
        });
};

// Export apiManager object with HTTP methods
export const apiManager = {
    get: (url, signal) => apiInterfaceForJson(url, 'GET', null, signal),
    post: (url, data, signal) => apiInterfaceForJson(url, 'POST', data, signal),
    put: (url, data, signal) => apiInterfaceForJson(url, 'PUT', data, signal),
    delete: (url, signal) => apiInterfaceForJson(url, 'DELETE', null, signal),
    postFormData: (url, formData) => apiInterfaceForFormData(url, 'POST', formData),
    putFormData: (url, formData) => apiInterfaceForFormData(url, 'PUT', formData)
};